import { gql } from '@apollo/client';

export const createFacilitySignIn = gql`
  mutation createFacilitySignIn($id: String, $input: FacilitySignInInput) {
    createFacilitySignIn(id: $id, input: $input) {
      id
      name
      contactNumber
      facilityId
      company
      gaveConsent
      takenOrientation
      signInTime
      signOutTime
    }
  }
`;
